module.exports = __webpack_public_path__ + "static/media/light_apps.32adb03e.svg";